export const formatPhoneNumber = (phone) => {
  if (!phone) return '-';
  // 숫자만 추출
  const numbers = phone.replace(/[^0-9]/g, '');
  
  // 길이에 따른 포맷팅
  if (numbers.length === 11) {
    // 휴대폰 번호 (01012345678 -> 010-1234-5678)
    return numbers.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  } else if (numbers.length === 10) {
    // 지역 번호 (0212345678 -> 02-1234-5678)
    return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
  } else if (numbers.length === 9) {
    // 지역 번호 (021234567 -> 02-123-4567)
    return numbers.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
  }
  return phone; // 기타 형식은 원본 반환
};

export const formatOpenDays = (openDays) => {
  if (!openDays) return '-';
  
  const days = openDays.split(',').map(Number);
  
  if (days.length === 7) {
    return '연중무휴';
  }
  
  const dayNames = ['일', '월', '화', '수', '목', '금', '토'];
  const selectedDays = days.map(day => dayNames[day]);
  
  if (days.length > 2) {
    const isConsecutive = days.every((day, index) => {
      if (index === 0) return true;
      return day === days[index - 1] + 1;
    });
    
    if (isConsecutive) {
      return `매주 ${selectedDays[0]}~${selectedDays[selectedDays.length - 1]}`;
    }
  }
  
  return `매주 ${selectedDays.join(', ')}`;
};